import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableFooter,
  TablePagination,
  Box,
  TextField,
  makeStyles,
} from '@material-ui/core';
import useSWR, { mutate } from 'swr';
import Breadcrumbs from 'components/Breadcrumbs';
import ApplicationLayout from 'components/layouts/ApplicationLayout';
import TablePaginationActions from 'components/table/TablePaginationActions';
import { useState } from 'react';
import { recalculateReport, getReportRepairStatus } from 'api/cms/maintenance';
import { toast } from 'react-toastify';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  dateField: { minWidth: 150, maxWidth: 200, width: '100%' },
}));
const RecalculateReport = () => {
  const classes = useStyles();
  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1))
    .toISOString()
    .split('T')[0];
  const [selectedDate, setSelectedDate] = useState(yesterday);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [recalculateTime, setRecalculateTime] = useState(0);

  const { data: reportData, error: reportError } = useSWR(
    ['getReportRepairStatus', recalculateTime],
    () => getReportRepairStatus({ page, limit: rowsPerPage }),
    {
      revalidateOnFocus: false,
    },
  );

  const handleRecalculate = () => {
    const date = new Date(selectedDate);
    if (isNaN(date.getTime())) {
      toast.error('Invalid date');
      return;
    }
    const minDate = new Date(dateRangeLimit.min);
    const maxDate = new Date(dateRangeLimit.max);

    if (date < minDate || date > maxDate) {
      toast.error(`Date must be between ${dateRangeLimit.min} and ${dateRangeLimit.max}`);
      return;
    }

    const fromDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    const toDate = new Date(fromDate);
    toDate.setDate(toDate.getDate() + 1);

    recalculateReport({
      from_time: fromDate.toISOString(),
      to_time: toDate.toISOString(),
      type: 'all',
    })
      .then((data) => {
        setRecalculateTime(Date.now());
        toast.success(data);
      })
      .catch((error) => {
        toast.error(_.get(error, 'response.data.message', 'error'));
      });
  };

  const getReportTime = (json) => {
    const data = JSON.parse(json);
    const dataValue = JSON.parse(data.Value);

    return `${dataValue.FromTime} - ${dataValue.ToTime}`;
  };

  const dateRangeLimit = {
    max: yesterday,
    min: new Date(new Date().setDate(new Date().getDate() - 35)) // 35 days ago
      .toISOString()
      .split('T')[0],
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    setRecalculateTime(Date.now());
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
    setRecalculateTime(Date.now());
  };

  return (
    <ApplicationLayout>
      <Breadcrumbs
        breadcrumbNameAddOn={{ [`${location.pathname}`]: 'Recalculate Report' }}
        renameByIndex={{ 1: 'Recalculate Report' }}
      />
      <Box mt={3}>
        <Grid container spacing={2} direction="row" alignItems="center">
          <Grid item>
            <TextField
              label="Select Date"
              type="date"
              variant="outlined"
              size="small"
              className={classes.dateField}
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              inputProps={dateRangeLimit}
            />
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" onClick={handleRecalculate}>
              Recalculate
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              <Table aria-label="table">
                <TableHead>
                  <TableRow>
                    <TableCell>Track ID</TableCell>
                    <TableCell>Track Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Updated At</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData?.data?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.track_id}</TableCell>
                      <TableCell>{getReportTime(row.message)}</TableCell>
                      <TableCell>{row.status}</TableCell>
                      <TableCell>{row.updated_at}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 50, 100]}
                      count={reportData?.page || 0}
                      rowsPerPage={rowsPerPage}
                      page={reportData ? page - 1 : 0}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </ApplicationLayout>
  );
};

export default RecalculateReport;
